"use strict";
/*
 * Created on 2019-04-11
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Product-level info - data aggregated from individual product-site items.
 * @author JMr
 * @author Radek Beran
 */


var SelloutReleaseCategoryTotalDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutReleaseCategoryTotalDTO, _DomainObject_1$Domai);

  /**
   * @param productId internal id of product
   * @param impact impact attributes aggregated to product-level
   * @param previousImpacts impact attributes aggregated to product-level for previous opens of release (for PROFACT-312)
   * @param validationResult alerts on product level
   * @param exportedCount count of exported sellout release items on product-site level
   * @param itemCount total count of aggregated sellout release items on product-site level
   * @param readonly true if all items for one product are readonly
   */
  function SelloutReleaseCategoryTotalDTO(productId, impact, previousImpacts, validationResult, exportedCount, itemCount, readonly) {
    var _this;

    _classCallCheck(this, SelloutReleaseCategoryTotalDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseCategoryTotalDTO).call(this));
    _this.productId = productId;
    _this.impact = impact;
    _this.previousImpacts = previousImpacts;
    _this.validationResult = validationResult;
    _this.exportedCount = exportedCount;
    _this.itemCount = itemCount;
    _this.readonly = readonly;
    return _this;
  }
  /**
   * LOG-4814: State of "Export" on aggregated product-level.
   */


  _createClass(SelloutReleaseCategoryTotalDTO, [{
    key: "isAllExported",
    value: function isAllExported() {
      return this.exportedCount === this.itemCount && this.itemCount > 0;
    }
  }]);

  return SelloutReleaseCategoryTotalDTO;
}(DomainObject_1.DomainObject);

exports.SelloutReleaseCategoryTotalDTO = SelloutReleaseCategoryTotalDTO;